import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const withAuth = (Component) => {
  const ProtectedRoute = (props) => {
    const navigate = useNavigate();

    useEffect(() => {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/auth/signin');
      }

      try {
        const decoded = jwtDecode(token);
        if (decoded.exp * 1000 < Date.now()) {
          navigate('/auth/signin');
        }
      } catch (error) {
        console.log(error);
        navigate('/auth/signin');
      }
    }, [navigate]);

    return <Component {...props} />;
  };

  return ProtectedRoute;
};

export default withAuth;